import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    // configuração the runtime => appconfig.js
    public apiServerUrl = window['appConfig'].Server; // endereço dos rest services
    public debugMode = window['appConfig'].DebugMode;
    public isIdentityServer = window['appConfig'].IdentityServer;

    // configuração de design time
    public application = 'ActiveRent - Boxer Clientes';
    public applicationLoginDescription = 'Portal de gestão para clientes';

    // Autenticação e expiração de autenticação, etc ...
    public expiresLoginPopup = 600;  // segundos para expiração do login => para abrir o popup de aviso (0 não abrir)
    public authenticationSlidingExpiration = 6000;  // segundos para expiração da autenticação por inactividade com o AppServer

    constructor() {
    }
}
